import { render, staticRenderFns } from "./MasterDataLaboratory.vue?vue&type=template&id=32f11c02"
import script from "./MasterDataLaboratory.vue?vue&type=script&lang=js"
export * from "./MasterDataLaboratory.vue?vue&type=script&lang=js"
import style0 from "./MasterDataLaboratory.vue?vue&type=style&index=0&id=32f11c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports